import React from "react";
import { Modal, Button } from 'react-bootstrap';

const DialogSave = ({ show, title, content, onClose, onConfirm, confirmButtonText = "OK", cancelButtonText }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      {title && <Modal.Header closeButton><Modal.Title>{title}</Modal.Title></Modal.Header>}
      <Modal.Body>{content}</Modal.Body>
      <Modal.Footer>
        {cancelButtonText && <Button variant="secondary" onClick={onClose}>{cancelButtonText}</Button>}
        <Button variant="primary" onClick={() => { 
          if (onConfirm) onConfirm();
          onClose();
        }}>
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DialogSave;
